import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { PurchaseOrderForm } from '@/components/forms/PurchaseOrderForm'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateClientPurchaseOrderPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/organization/client-purchase-orders')
  }

  const handleCancel = () => {
    navigate('/organization/client-purchase-orders')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create Purchase Order</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new purchase order for a client tenant
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <PurchaseOrderForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
